import Link from '@/components/atoms/legacy/Link/Link';
import { Skeleton } from '@/components/atoms/Skeleton';
import ClampedText from '@/components/molecules/ClampedText';
import { GOOGLE_TRACK_INFO } from '@/lib/constants';
import { BlogPreview } from '@/types/blog';
import clsx from 'clsx';
import Image from 'next/image';
import React from 'react';

interface BlogListingLinkProps {
  layout?: 'row' | 'column';
  blog: BlogPreview;
  showExcerpt?: boolean;
  titleVariant?: 'large' | 'small';
}

/** @deprecated
 * Use `ArticleCardSkeleton` instead
 */
export const BlogListingLinkSkeleton = ({
  layout,
}: Pick<BlogListingLinkProps, 'layout'>) => {
  return (
    <div
      className={`flex h-full w-full rounded-small bg-white ${layout === 'column' ? 'flex-col' : 'flex-row'}`}
    >
      <Skeleton
        className={clsx('flex', {
          'h-[260px] w-full': layout === 'column',
          'h-full w-[302px]': layout === 'row',
        })}
      />
      <section className="flex flex-1 flex-col items-start justify-start gap-s p-l">
        <Skeleton className="h-[20px] w-[40px]" />
        <Skeleton className="h-[22px] w-full" />
      </section>
    </div>
  );
};

/** @deprecated
 * Use `ArticleCard` instead
 */
export const BlogListingLink: React.FC<BlogListingLinkProps> = ({
  blog,
  layout = 'column',
  showExcerpt = false,
  titleVariant = 'small',
}) => {
  return (
    <Link
      href={`/news/${blog.slug}`}
      analyticsEvent={{
        ...GOOGLE_TRACK_INFO.blogArticlePageButton,
        pageTarget: `/news/${blog.slug}`,
      }}
    >
      <div
        className={clsx('flex h-full w-full rounded-small bg-white', {
          'flex-col': layout === 'column',
          'flex-row': layout === 'row',
        })}
      >
        {!!blog?.image && layout === 'column' && (
          <div className="flex flex-1">
            <Image
              src={blog.image}
              alt="Article image"
              width={1600}
              height={900}
              className="aspect-[16/9] h-full w-full rounded-t-small object-cover"
            />
          </div>
        )}
        {layout === 'row' && blog.thumbnail && (
          <div className={'flex flex-col justify-center'}>
            <Image
              src={blog.thumbnail.source_url}
              alt="Article image"
              width={blog.thumbnail.width}
              height={blog.thumbnail.height}
              className={'h-full rounded-l-small'}
            />
          </div>
        )}
        <section className="flex flex-1 flex-col items-start justify-start p-l">
          <ClampedText className="mb-xs text-body1Light text-neutral-800">
            {blog?.categories?.join(', ').toUpperCase()}
          </ClampedText>
          {titleVariant === 'large' ? (
            <h4
              className={clsx('text-h4SemiBold text-neutral-900', {
                'mb-s': showExcerpt,
              })}
            >
              {blog.title}
            </h4>
          ) : (
            <p className="text-h5Medium text-neutral-900">{blog.title}</p>
          )}
          {showExcerpt && (
            <div>
              <span className="line-clamp-4 text-h5Light text-neutral-900">
                {blog.excerpt}
              </span>
            </div>
          )}
        </section>
      </div>
    </Link>
  );
};
